import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import {NglInputModule, NglButtonsModule, NglSpinnersModule, NglAlertModule} from 'ng-lightning';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { StorageServiceModule} from 'angular-webstorage-service';
import { MatDialogModule } from '@angular/material';

const routes: Routes = [
  {path: '', component: LoginComponent}
];

@NgModule({
  declarations: [LoginComponent],
  exports: [LoginComponent],
  imports: [
    CommonModule,
    FormsModule,
    NglInputModule,
    NglSpinnersModule,
    NglAlertModule,
    NglButtonsModule,
    TranslateModule,
    StorageServiceModule,
    HttpClientModule,
    MatDialogModule,
    RouterModule.forChild(routes)
  ]
})

export class LoginModule { }
